export const enum OnboardingPlatform {
  Web = 'web',
  Mobile = 'mobile',
}
